<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableVirtualPrivateCloudResourceVue = {};
export default {
  name: "TableVirtualPrivateCloudResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.AWS.VirtualNetwork.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.VirtualNetwork.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.VirtualNetwork.VPCName"),
          key: "name"
        },
        {
          title: "VPC ID",
          key: "vpcId"
        },
        {
          title: "VPC CIDR",
          key: "vpcCidr"
        },
        {
          title: this.$t("RAM.AWS.VirtualNetwork.routeTableId"),
          key: "routeTableId"
        },
        {
          title: this.$t("RAM.AWS.VirtualNetwork.DHCPSettingSet"),
          key: "dhcpOptionsSet"
        },
        {
          title: this.$t("RAM.AWS.VirtualNetwork.defaultVPC"),
          key: "defaultVpc"
        },
        {
          title: this.$t("RAM.AWS.VirtualNetwork.runningStatus"),
          key: "stateName"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableVirtualPrivateCloudResourceVue = this;
  },
  mounted: function() {},
  created() {
    eventBus.$on("accountName", function(val) {
      tableVirtualPrivateCloudResourceVue.accountName = val;
    });
    eventBus.$on("companyId", function(val) {
      tableVirtualPrivateCloudResourceVue.companyId = val;
    });
  },
  methods: {
    showAll: function() {
      tableVirtualPrivateCloudResourceVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .selectAWSVpcByPage({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableVirtualPrivateCloudResourceVue.companyId,
          accountName: tableVirtualPrivateCloudResourceVue.accountName,
          accountType: 0
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableVirtualPrivateCloudResourceVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableVirtualPrivateCloudResourceVue.getData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/vpc/TableVirtualPrivateCloudResource.vue